import React from 'react'

import {
  // FullWidth,
  QuestionLabel,
  QuestionRow,
  // ToggleButton,
  ToggleGroup,
  // DependentFieldWrapper,
} from './ToggleField.style'
import {Button} from '../../../../shared/Button'
import {LabelReq} from '../../../../shared/Input/Input.styles'

// import {TextField} from './TextField'
// import {AsyncSearchField} from './AsyncSearchField'

// const DEPENDENT_FIELDS = {
//   salesRepOrPartner: {
//     'sales-rep': {
//       component: AsyncSearchField,
//       field: {
//         key: 'salesRepInfo',
//         label: 'Search by Name',
//         placeholder: 'Search by Name',
//         layout: 'grid',
//         validators: ['required'],
//       },
//     },

//     partner: {
//       component: TextField,
//       field: {
//         key: 'xpCode',
//         label: 'Please enter XP Code',
//         placeholder: 'XP Code',
//         layout: 'grid',
//         validators: ['required'],
//       },
//     },
//   },

//   overrideSST: {
//     yes: {
//       component: AsyncSearchField,
//       field: {
//         key: 'overrideRepInfo',
//         label: 'Search by Name',
//         placeholder: 'Search by Name',
//         layout: 'grid',
//         validators: ['required'],
//       },
//     },
//   },
// }

export function ToggleRep({
  field,
  value,
  values,
  variant,
  size,
  disabled,
  error,
  touched,
  submitted,

  onBlur = () => {},
  onChange,
}) {
  // const isSalesRepOrPartner = field.key === 'salesRepOrPartner'
  // const isOverrideSST = field.key === 'overrideSST'
  // const dependentConfig = DEPENDENT_FIELDS[field.key]?.[value]

  // const DependentComponent = dependentConfig?.component

  // const dependentField = dependentConfig?.field

  return (
    <>
      {/* Toggle Row */}
      <QuestionRow>
        <QuestionLabel>
          {field.label}
          {field.required && (
            <LabelReq variant="form" style={{display: 'inline'}}>
              {' '}
              *
            </LabelReq>
          )}
        </QuestionLabel>

        <ToggleGroup disabled={disabled}>
          {field.options?.map(option => (
            <Button
              key={option.value}
              size="sm"
              variant={
                value === option.value
                  ? 'secondary-toggle-active'
                  : 'secondary-toggle-inactive'
              }
              disabled={disabled}
              onClick={() => onChange(field.key, option.value)}
            >
              {option.label}
            </Button>
          ))}
        </ToggleGroup>
      </QuestionRow>

      {/* Dependent Field */}
      {/* {DependentComponent && dependentField && (
        <DependentFieldWrapper>
          <DependentComponent
            field={dependentField}
            value={values[dependentField.key]}
            values={values}
            variant={variant}
            size={size}
            disabled={disabled}
            error={error}
            touched={touched}
            submitted={submitted}
            onBlur={onBlur}
            onChange={onChange}
          />
        </DependentFieldWrapper>
      )} */}
    </>
  )
}

// import React from 'react'

// import {
//   FullWidth,
//   QuestionLabel,
//   QuestionRow,
//   ToggleButton,
//   ToggleGroup,
//   DependentFieldWrapper,
// } from './ToggleField.style'
// import {TextField} from './TextField'
// import {AsyncSearchField} from './AsyncSearchField'

// export function ToggleRep({
//   field,
//   value,
//   values,
//   variant,
//   size,
//   disabled,
//   error,
//   touched,

//   onBlur = () => {},
//   onChange,
// }) {
//   // const isSalesRepOrPartner = field.key === 'salesRepOrPartner'

//   // const isOverrideSST = field.key === 'overrideSST'

//   // const showSalesRepInfo = isSalesRepOrPartner && field.key === 'salesRepInfo'

//   // const showXpCode = isSalesRepOrPartner && field.key === 'xpCode'

//   // const showOverrideRepInfo = isOverrideSST && field.key === 'overrideRepInfo'

//   return (
//     <FullWidth>
//       {/* ALWAYS SINGLE LINE */}
//       <QuestionRow>
//         <QuestionLabel>{field.label}</QuestionLabel>

//         <ToggleGroup>
//           {field.options?.map(option => (
//             <ToggleButton
//               key={option.value}
//               type="button"
//               isActive={value === option.value}
//               disabled={disabled}
//               onClick={() => onChange(field.key, option.value)}
//             >
//               {option.label}
//             </ToggleButton>
//           ))}
//         </ToggleGroup>
//       </QuestionRow>

//       {/* SALES REP SEARCH */}
//       {/* {showSalesRepInfo && ( */}
//       <DependentFieldWrapper>
//         <AsyncSearchField
//           field={field}
//           value={value}
//           values={values}
//           variant={variant}
//           size={size}
//           disabled={disabled}
//           error={error}
//           touched={touched}
//           onBlur={onBlur}
//           onChange={onChange}
//         />
//       </DependentFieldWrapper>
//       {/* )} */}

//       {/* XP CODE */}
//       {/* {showXpCode && ( */}
//       <DependentFieldWrapper>
//         <TextField
//           field={field}
//           value={value}
//           values={values}
//           variant={variant}
//           size={size}
//           disabled={disabled}
//           error={error}
//           touched={touched}
//           onBlur={onBlur}
//           onChange={onChange}
//         />
//       </DependentFieldWrapper>
//       {/* )} */}

//       {/* OVERRIDE REP INFO */}
//       {/* {showOverrideRepInfo && ( */}
//       <DependentFieldWrapper>
//         <AsyncSearchField
//           ffield={field}
//           value={value}
//           values={values}
//           variant={variant}
//           size={size}
//           disabled={disabled}
//           error={error}
//           touched={touched}
//           onBlur={onBlur}
//           onChange={onChange}
//         />
//       </DependentFieldWrapper>
//       {/* )} */}
//     </FullWidth>
//   )
// }
